import debounce from 'lodash.debounce';
import { Options } from 'vue-class-component';
import AssignRoomObjectGeneralStep from '../AssignRoomObjectGeneralStep';
import { RoomObjectType } from '@/../client-generator/generated-clients/plants';
import FieldsLight from './ObjectFields/FieldsLight.vue';
import FieldsShutter from './ObjectFields/FieldsShutter.vue';
import FieldsFancoil from './ObjectFields/FieldsFancoil.vue';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { NamingService } from '@/core/services/naming.service';
import { PlantEntityType } from '@/../client-generator/generated-clients/configurations';
import { NAME_VALIDATION_DEBOUNCE_TIME } from '@/core/utils/utils';

@Options({
  name: 'Step1',
  components: {
    FieldsLight,
    FieldsShutter,
    FieldsFancoil,
  },
  watch: {
    'roomObject.name': function () {
      this.verifyValidityOfName();
    },
  },
})
export default class Step1 extends AssignRoomObjectGeneralStep {
  isValidName = true;
  initialName!: string;
  invalidNameReason: string = '';

  mounted() {
    this.initialName = this.roomObject.name ?? '';

    this.verifyValidityOfName = debounce(
      this.verifyValidityOfName,
      NAME_VALIDATION_DEBOUNCE_TIME
    );
  }

  private async verifyValidityOfName() {
    this.$store.dispatch(SET_APP_LOADING, true);
    const validName = await NamingService.isValidEntityTypeName(
      this.roomObject.name
    );

    if (this.initialName !== this.roomObject.name && !validName) {
      const suggestedName = await NamingService.suggestNextValidEntityName({
        eType: PlantEntityType.ROOM_OBJECT,
        plantId: this.plantId,
        metadata: {
          roomType: +this.roomType,
          roomObjectType: this.roomObject.type,
          room: { name: this.roomName } as any,
        },
      });
      this.isValidName = validName;
      this.invalidNameReason = this.$t(
        `uniqueNaming.validationErrorWithSuggestion`,
        { suggestedName }
      );
      this.$emit('next-enabled', false);
    } else {
      this.isValidName = true;
      this.invalidNameReason = '';
      this.$emit('next-enabled', true);
    }
    this.$store.dispatch(SET_APP_LOADING, false);
  }

  get fieldsComponent() {
    const typeMap: {
      [key: string]: string;
    } = {
      [RoomObjectType.Light]: 'Light',
      [RoomObjectType.Shutter]: 'Shutter',
      [RoomObjectType.Socket]: 'Socket',
      [RoomObjectType.Lock]: 'Lock',
      [RoomObjectType.Fancoil]: 'Fancoil',
      [RoomObjectType.TowelWarmer]: 'TowelWarmer',
      [RoomObjectType.WirelessCommand]: 'WirelessCommand',
      [RoomObjectType.Player]: 'Player',
      [RoomObjectType.None]: '',
      '': '',
    };
    return `Fields${typeMap[this.roomObject.type ?? '']}`;
  }
}
